<div>
  <div class="header-style">
    <div class="h-100 d-flex">
      <mat-form-field appearance="outline" class="filter-style">
        <mat-select data-testid="used_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #used_filter  id="used_filter"
          name="used_filter" i18n-aria-label="@@usedFilterAriaLabel" aria-label="Used Filter">
          <mat-option i18n="@@all" value="all">All</mat-option>
          <mat-option i18n="@@used" value="used">Used</mat-option>
          <mat-option i18n="@@notUsed" value="not-used">Not Used</mat-option>
        </mat-select>
      </mat-form-field>
      @if (showSelect && selected != 'used') {
        <button i18n="@@sendEmail" i18n-aria-label="@@sendEmailButton" aria-label="Send Email" class="ml-10" data-testid="send_email_button" (click)="sendEmails()" mat-raised-button color="accent">Send email</button>
      }
      @if (!showSelect) {
        <div class="ml-10"></div>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      @if (selected != 'used') {
        <mat-icon data-testid="email_promotion_button" i18n-aria-label="@@selectPromotionsAriaLabel" aria-label="Select Promotions" (click)="toggleSelect()" class="{{showSelect ? 'cursor add-icon header-email-icon' : 'email-color cursor add-icon header-email-icon'}}">email</mat-icon>
      }
      <mat-icon data-testid="add_promotion_button" i18n-aria-label="@@addPromotionAriaLabel" aria-label="Add Promotion" (click)="openAddPromotion()" class="cursor add-icon"  svgIcon="add" aria-hidden="false"></mat-icon>
      
      @if (promotionsList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item (click)="exportPromotions(1)" i18n="@@exportCSV" i18n-aria-label="@@exportCSVAriaLabel" aria-label="Export as CSV">Export as CSV</button>
          <button mat-menu-item (click)="exportPromotions(2)" i18n="@@exportPDF" i18n-aria-label="@@exportPDFAriaLabel" aria-label="Export as PDF">Export as PDF</button>
          <button mat-menu-item (click)="exportPromotions(3)" i18n="@@exportExcel" i18n-aria-label="@@exportExcelAriaLabel" aria-label="Export as Excel">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" i18n-aria-label="@@exportMenuAriaLabel" aria-label="Export Promotions" aria-hidden="false" [matMenuTriggerFor]="exportMenu"></mat-icon>
      }
      
      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="promotions_search_input" matInput formControlName="sponsorSearch" id="sponsorSearch" placeholder="Search" name="sponsorSearch"/>
            <mat-icon data-testid="promotions_clear_button" class="cursor" matSuffix i18n-aria-label="@@clearSearchAriaLabel" aria-label="Clear Search" (click)="clearSearch()">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="promotions_search_button" i18n-aria-label="@@searchButtonAriaLabel" aria-label="Search" (click)="handleSearchClick()" class="cursor"  svgIcon="search" aria-hidden="false"></mat-icon>
    </div>
  </div>
  @for (item of promotionsList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16 ' : 'lite-box-without-img')}}">
      <mat-card-content class="content-box">
        <div>
          <div class="mat-subtitle-1 mb-8 d-inline" matTooltip ellipsisTooltip><span i18n="@@code">Code: </span> {{item.code}}</div>
          <div class="mat-caption mb-8 d-inline" matTooltip ellipsisTooltip><span i18n="@@status">Status: </span> {{item.isUsed ? 'Used' : 'Not Used'}}</div>
          <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.expireDate}}</div>
          <div class="mat-caption mb-8 d-inline" matTooltip ellipsisTooltip>@if (item.isUsed) {
            <span i18n="@@companyUsed">Company Used: {{item.companyName}} </span>
            }@if (!item.isUsed) {
            <span>.</span>
          }</div>
        </div>
        @if (!showSelect) {
          <mat-icon data-testid="promotions_delete_button" i18n-aria-label="@@deletePromotionAriaLabel" aria-label="Delete Promotion" class="cursor" color="warn" (click)="deletePromotion(item.id, item.code)" aria-hidden="false">delete_outline</mat-icon>
        }
        @if (showSelect && !item.isUsed) {
          <mat-checkbox i18n-aria-label="@@selectPromotionCheckboxAriaLabel" aria-label="Select Promotion" (change)="onCheckChange(item, $event.checked)" class="one-checkbox"></mat-checkbox>
        }
      </mat-card-content>
    </mat-card>
  }
  @if (promotionsList.length === 0) {
    <img class="empty-view-img" i18n-alt="@@emptyPromotionsImageAlt" alt="No promotions available" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}">
  }
</div>
